import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, useLiveRefresh, useDebouncedCallback } from '@byscott-io/corebyscott';
import { useWaldoEvent } from '@byscott-io/where-is-waldo';
import { dashboard } from '../api/client';

export default function Dashboard() {
  const { user, currentAccount } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadDashboard = async () => {
    try {
      const response = await dashboard.get();
      setStats(response.data.dashboard);
    } catch (err) {
      console.error('Failed to load dashboard:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDashboard();
  }, []);

  // Live dashboard (#626): refresh on billing lifecycle events. Debounced +
  // form-safe (defers while a form is open).
  const refresh = useLiveRefresh(useDebouncedCallback(loadDashboard, 1000));
  useWaldoEvent(
    [
      "app_created", "app_update", "app_destroyed",
      "product_created", "product_update", "product_destroyed",
      "client_account_created", "client_account_update", "client_account_destroyed",
      "subscription_created", "subscription_update", "subscription_destroyed",
    ],
    refresh
  );

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>

      <div className="bg-white shadow rounded-lg p-6 mb-6">
        <h2 className="text-lg font-semibold mb-4">Welcome, {user?.first_name}!</h2>
        <p className="text-gray-600">
          You are logged into <strong>{currentAccount?.name}</strong>.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Link to="/app/apps" className="bg-white shadow rounded-lg p-6 hover:shadow-md transition-shadow">
          <h3 className="text-lg font-semibold mb-2">Apps</h3>
          <p className="text-3xl font-bold text-blue-600">
            {loading ? '...' : stats?.apps_count ?? 0}
          </p>
          <p className="text-gray-500 text-sm">Registered apps</p>
        </Link>

        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-2">Client Accounts</h3>
          <p className="text-3xl font-bold text-green-600">0</p>
          <p className="text-gray-500 text-sm">Total clients</p>
        </div>

        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-2">Revenue</h3>
          <p className="text-3xl font-bold text-purple-600">$0</p>
          <p className="text-gray-500 text-sm">This month</p>
        </div>
      </div>
    </div>
  );
}
